import React from 'react';

var __defProp = Object.defineProperty;
var __name = (target, value) => __defProp(target, "name", { value, configurable: true });
const IcIot = /* @__PURE__ */ __name((properties) => /* @__PURE__ */ React.createElement("svg", {
  fill: "none",
  height: "24",
  width: "24",
  xmlns: "http://www.w3.org/2000/svg",
  ...properties
}, /* @__PURE__ */ React.createElement("path", {
  d: "M10.068 5.125a4.25 4.25 0 0 1 7.924 2.38 1 1 0 0 0 .826 1.044A3.251 3.251 0 0 1 19 14.913v2.034a5.251 5.251 0 0 0 .984-10.154A6.25 6.25 0 0 0 8.828 3.397a4.002 4.002 0 0 0-5.062 3.491A5.25 5.25 0 0 0 5 16.947v-2.034a3.251 3.251 0 0 1 .001-6.327 1 1 0 0 0 .764-1.093A2 2 0 0 1 8.718 5.5a1 1 0 0 0 1.35-.374Z",
  fill: "var(--mds-nav-icon-weak)"
}), /* @__PURE__ */ React.createElement("path", {
  d: "M16.1 14.158a1.999 1.999 0 0 1-1.5-.122V17.5a.75.75 0 0 0 .24.549l1.91 1.777V22a.75.75 0 0 0 1.5 0v-2.5a.75.75 0 0 0-.24-.55l-1.91-1.777v-3.015Zm-3.35-3.054a1.994 1.994 0 0 1-1.5 0V22a.75.75 0 0 0 1.5 0V11.104ZM9.4 18.5v-3.464a1.991 1.991 0 0 1-1.5.122v3.015l-1.91 1.778a.75.75 0 0 0-.24.549V22a.75.75 0 0 0 1.5 0v-1.174l1.91-1.777a.75.75 0 0 0 .24-.55Z",
  fill: "var(--mds-nav-icon-medium)"
}), /* @__PURE__ */ React.createElement("path", {
  d: "M13.5 9.25a1.5 1.5 0 1 1-3 0 1.5 1.5 0 0 1 3 0Zm-3.5 4a1.5 1.5 0 1 1-3 0 1.5 1.5 0 0 1 3 0Zm5.5.5a1.5 1.5 0 1 0 0-3 1.5 1.5 0 0 0 0 3Z",
  fill: "var(--mds-nav-icon-accent)"
})), "IcIot");

export { IcIot };
//# sourceMappingURL=ic-iot.js.map
